import React from "react";
import { ReactComponent as ArrowDown } from "../../../shared/assets/Icons/IconArrowDown.svg";
import { ReactComponent as ArrowUp } from "../../../shared/assets/Icons/IconArrowUp.svg";
import { SpeedboxGauge } from "@ui-components/GaugeChart/SpeedboxGauge";
import { formatDataRate, formatDataRateSmart } from "kontrolEdge/helpers/formatDataRate";
import { HorizontalStackedBar } from "@ui-components/StackedBar/GenericStackbar";

interface ServiceUsageChartProps {
  serviceName: string;
  allocated: number;
  consumption: number;
  incomingValue: number;
  outgoingValue: number;
  colorAllocated?: string;
  colorConsumption?: string;
}

export const ServiceUsageChart: React.FC<ServiceUsageChartProps> = ({
  serviceName,
  allocated,
  consumption,
  incomingValue = 0,
  outgoingValue = 0,
}) => {
  // Percent used
  // const pctUsed = allocated > 0 ? (consumption / allocated) * 100 : 0;
  // const pctFree = 100 - pctUsed;
  const incomingMbps = Number.isFinite(incomingValue) ? incomingValue : 0;
  const outgoingMbps = Number.isFinite(outgoingValue) ? outgoingValue : 0;
  const consumptionMbps = incomingMbps + outgoingMbps;

  const pctUsedRaw = allocated > 0 ? (consumptionMbps / allocated) * 100 : 0;
  const pctUsed = Math.max(0, Math.min(100, pctUsedRaw));
  const pctFree = Math.max(0, 100 - pctUsed);

  const safeIncoming = typeof incomingValue === 'number' && !isNaN(incomingValue)
  ? incomingValue
  : 0;
  const safeOutgoing = typeof outgoingValue === 'number' && !isNaN(outgoingValue)
  ? outgoingValue
  : 0;


  const downValue = safeIncoming + safeOutgoing;

    return (
      <>
      <div className="pt-5">
        <div className="flex-wrap justify-center items-stretch">
          <h3 className="w-full text-semantic-text-primary text-lg text-left font-bold">
            Current Bandwidth Utilization
          </h3>
          <h4 className="w-full text-semantic-text-secondary text-md text-left font-bold mb-10">
            {serviceName}: {formatDataRate(consumption)} / {formatDataRate(allocated)}
          </h4>
        </div>
        {/* GAUGE CHART*/}
        <div className="w-full flex-wrap items-center justify-center">
          <SpeedboxGauge
            percent={pctUsed}
            down={downValue}
          />
        </div>

        {/* BAR CHART + LABELS */}
        <div className="flex-wrap justify-center items-stretch mt-10 border-t border-gray-300">
        <h4 className="w-full text-md text-left font-bold mt-5">
              Bandwidth Utilization (%)
          </h4>
          <div className="w-full h-20 mt-10 px-5">
            <div className="mt-6">
              <HorizontalStackedBar
                usedPct={parseFloat(pctUsed.toFixed(1))}
                freePct={parseFloat(pctFree.toFixed(1))}
              />
            </div>
              {/* LABELS IN / OUT */}
              <div className="flex justify-between mt-2 text-sm">
                <div className="flex items-center">
                  <ArrowDown className="h-4 w-4 text-green-500 mr-1" />
                  In: {formatDataRateSmart(incomingMbps)}
                  {/* In: {formatBandwidth(incomingValue)} */}
                </div>
                <div className="flex items-center">
                  <ArrowUp className="h-4 w-4 text-blue-500 mr-1" />
                  Out: {formatDataRateSmart(outgoingMbps)}
                  {/* Out: {formatBandwidth(outgoingValue)} */}
                </div>
              </div>
          </div>
        </div>
    </div>
    </>
  );
};